"use client";

import React from "react";
import Link from "next/link";
import ReactCookieConsent from "react-cookie-consent";

const styles = new Proxy({"CookieConsent":"CookieConsent-2bcac","Button":"Button-2bcac"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const CookieConsent = () => (
  <ReactCookieConsent
    location="bottom"
    buttonText="Consent"
    cookieName="Graboxy Captcha Landing"
    containerClasses={styles.CookieConsent}
    style={{ background: "#132735" }}
    buttonClasses={`ButtonPrimary ${styles.Button}`}
    expires={150}
  >
    This website uses <Link href="/document/cookie-policy">cookies</Link> to
    enhance the user experience.
  </ReactCookieConsent>
);

export default CookieConsent;
